import {trackEvent} from '../tracking'

export const trackPageOpen = () => trackEvent({name: 'page.open', groupId: 'page.events.group'})
